module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart-fill-6f9d9c26.svg";